'use strict';

exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var logSessionIdentity = function logSessionIdentity() {
  _classCallCheck(this, logSessionIdentity);

  this.sessionTimeStamp = 0;
  this.deviceId = '00000000-0000-0000-0000-000000000000';
  this.token = '00000000-0000-0000-0000-000000000000';
  this.emptyGuid = '00000000-0000-0000-0000-000000000000';

  this.sessionTimeStamp = new Date().getTime();
}

/**
 * Session UTC timestamp
 * @type {number}
 * @description used to associate logged events to a common key property prior to initialization
 * of more common deviceId, userId, or token properties. Initialized on instantiation.
 */


/**
 * deviceId GUID
 * @type {string}
 * @description deviceId is assigned following application bootstrap, and does not require authentication
 */


/**
 * token GUID
 * @type {string}
 * @description token is assigned following successful authentication
 */


/**
 * EMPTY GUID value for evaluation
 * @type {string}
 * @description default value assigned to deviceId and token property members
 * intended use: for evaluation to determine if assignment was performed
 * e.g. instance.token !== instance.emptyGUID;
 */
;

exports.default = logSessionIdentity;


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/elk/log.session.identity.js
// module id = 343
// module chunks = 0